module.exports = __webpack_public_path__ + "static/media/platinum-partner1.1e2e3fab.png";